import type { BiometricKind } from './biometricDevice';

import { IconFingerprint } from '@tabler/icons-react';

/** Tabler's face icon reads as a generic avatar; this follows the Face ID glyph people recognise. */
function FaceIdGlyph({ size }: { size: number }) {
	return (
		<svg
			aria-hidden="true"
			viewBox="0 0 24 24"
			width={size}
			height={size}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.8}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M3 8V5.5A2.5 2.5 0 0 1 5.5 3H8" />
			<path d="M16 3h2.5A2.5 2.5 0 0 1 21 5.5V8" />
			<path d="M21 16v2.5a2.5 2.5 0 0 1-2.5 2.5H16" />
			<path d="M8 21H5.5A2.5 2.5 0 0 1 3 18.5V16" />
			<path d="M8.5 8.5V10" />
			<path d="M15.5 8.5V10" />
			<path d="M12.25 8.5v4.25a.75.75 0 0 1-.75.75H11" />
			<path d="M8.75 16.25a4.6 4.6 0 0 0 6.5 0" />
		</svg>
	);
}

export function BiometricIcon({ kind, size = 18 }: { kind: BiometricKind; size?: number }) {
	return kind === 'face' ? <FaceIdGlyph size={size} /> : <IconFingerprint size={size} stroke={1.8} />;
}
